import type { CityConfig } from "../city-template/types";

export const fredericksburgVaConfig: CityConfig = {
  city: "Fredericksburg",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "fredericksburg-va",
  route: "/cities/fredericksburg-va",
  title: "Emergency Passport Fredericksburg, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Fredericksburg, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Fredericksburg, Spotsylvania, Stafford, and the Rappahannock region. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Fredericksburg, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Spotsylvania, Stafford, or the Rappahannock region? We help Fredericksburg travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20downtown%20Fredericksburg%20Virginia%20with%20charming%20colonial%20brick%20buildings%20along%20Caroline%20Street%2C%20Civil%20War%20era%20architecture%2C%20the%20Rappahannock%20River%20waterfront%20in%20the%20background%2C%20warm%20afternoon%20golden%20light%2C%20professional%20photography%20showcasing%20the%20Historic%20Downtown%20area%20with%20tree-lined%20streets%20and%20American%20flags%2C%20no%20people%20visible%2C%20scenic%20small%20city%20with%20deep%20historical%20character%20and%20riverside%20backdrop&width=1800&height=700&seq=fredericksburg-va-hero-001&orientation=landscape",
  heroImageAlt: "Historic downtown Fredericksburg Virginia with colonial brick buildings and Rappahannock River waterfront",
  geoPosition: "38.3032;-77.4605",
  geoPlacename: "Fredericksburg, Virginia",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 55 miles north of Fredericksburg via I-95",
  },
  nearbyCitiesZips: [
    { name: "Fredericksburg", zips: "22401, 22402, 22403, 22404, 22405, 22406, 22407, 22408" },
    { name: "Spotsylvania", zips: "22551, 22553" },
    { name: "Stafford", zips: "22554, 22555, 22556" },
    { name: "Culpeper", zips: "22701" },
    { name: "King George", zips: "22485" },
    { name: "Woodbridge", zips: "22191, 22192, 22193, 22194, 22195" },
    { name: "Manassas", zips: "20108, 20109, 20110, 20111, 20112" },
    { name: "Charlottesville", zips: "22901, 22902, 22903, 22911" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225" },
    { name: "Arlington", zips: "22201, 22202, 22203, 22204, 22205" },
    { name: "Alexandria", zips: "22301, 22302, 22303, 22304, 22305, 22306, 22307, 22308, 22309, 22310, 22311, 22312, 22313, 22314, 22315" },
    { name: "Warrenton", zips: "20186, 20187, 20188" },
    { name: "Orange", zips: "22960" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the Rappahannock region" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Rappahannock Region Hub", desc: "Serving Fredericksburg, Spotsylvania, Stafford, King George, and Culpeper" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Arlington VA passport services", route: "/cities/arlington-va" },
    { name: "Richmond VA passport services", route: "/cities/richmond-va" },
    { name: "Charlottesville VA passport services", route: "/cities/charlottesville-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Fredericksburg remotely via secure courier. We do not have a walk-in office in Fredericksburg — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Fredericksburg and Rappahannock region travelers.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeDistance: "Serving all of Fredericksburg and the surrounding Rappahannock region including Spotsylvania County, Stafford County, King George County, Culpeper, and the I-95 corridor between DC and Richmond",
  serviceAreaIntro: "From the historic brick-lined streets of Old Town Fredericksburg to the sprawling suburbs of Spotsylvania and Stafford, from the University of Mary Washington campus to the Civil War battlefields of the Rappahannock region, from the King George County waterfront to the growing communities along Route 1 — Fast Passport Center serves every corner of Fredericksburg and the greater Rappahannock Valley. We regularly help travelers from Woodbridge, Culpeper, Warrenton, and Orange get their passports fast.",
  nearbyCitiesIntro: "We serve all Fredericksburg neighborhoods and the surrounding Rappahannock region including Spotsylvania, Stafford, King George, Culpeper, Warrenton, Orange, Woodbridge, and all I-95 corridor communities between DC and Richmond.",
  howItWorksIntro: "Most Fredericksburg travelers complete everything online and ship documents overnight. No need to battle I-95 traffic into Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "Fredericksburg travelers often consider battling I-95 traffic to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Fredericksburg and Rappahannock region travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Fredericksburg? Here are the most common ones we hear from Rappahannock region travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect I-95 traffic + wait all day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Fredericksburg international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Katherine R.",
      location: "Fredericksburg, VA",
      rating: 5,
      text: "I live near the University of Mary Washington and needed an emergency passport for a conference in Paris with 5 days notice. Fast Passport Center had my renewal in 3 days — I shipped from the UPS on Carl D. Silver Pkwy. Saved me a brutal I-95 drive into DC. Absolutely worth every penny.",
      service: "Emergency Passport",
    },
    {
      name: "Marcus T.",
      location: "Spotsylvania, VA",
      rating: 5,
      text: "As a Spotsylvania County resident I thought I'd have to sit in I-95 traffic just to get my passport expedited. Fast Passport Center made it seamless — everything online, mailed from my local UPS. My renewal was back in 4 days. The convenience for Northern Virginia corridor travelers is unmatched.",
      service: "Passport Renewal",
    },
    {
      name: "Diane W.",
      location: "Stafford, VA",
      rating: 5,
      text: "First passports for my three kids before a cruise to the Bahamas. Fast Passport Center handled all the parental consent requirements perfectly and had all three passports in 6 days. For Stafford families, this is the only way to go — no office visits, no waiting in line at the post office.",
      service: "Child Passport",
    },
    {
      name: "Robert H.",
      location: "Culpeper, VA",
      rating: 5,
      text: "Lost my passport 3 days before a flight to Germany for a business deal. I live in Culpeper and was in complete panic mode. Fast Passport Center had a replacement passport overnight-shipped to me within 48 hours. They literally saved my company a six-figure contract. Cannot recommend them enough.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "fredericksburg-va-1",
      name: "Fredericksburg Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Fredericksburg",
      state: "VA",
      zip: "22401",
      phone: "(540) 373-4181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Fredericksburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Fredericksburg facility. Full passport services with appointment. Call ahead to confirm availability.",
      icon: "ri-mail-line",
    },
    {
      id: "fredericksburg-va-2",
      name: "Spotsylvania Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Spotsylvania",
      state: "VA",
      zip: "22551",
      phone: "(540) 582-3363",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Spotsylvania County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Spotsylvania County residents. Full passport acceptance with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "fredericksburg-va-3",
      name: "Stafford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Stafford",
      state: "VA",
      zip: "22554",
      phone: "(540) 659-1116",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Stafford County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Stafford County and Route 1 corridor. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "fredericksburg-va-4",
      name: "Culpeper Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Culpeper",
      state: "VA",
      zip: "22701",
      phone: "(540) 825-8087",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Culpeper, west of Fredericksburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Culpeper County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "fredericksburg-va-5",
      name: "Fredericksburg City Circuit Court Clerk",
      type: "County Clerk",
      address: "2801 Courthouse Rd",
      city: "Virginia Beach",
      state: "VA",
      zip: "22401",
      phone: "(540) 372-1066",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Fredericksburg",
      website: "https://www.fredericksburgva.gov",
      websiteLabel: "City of Fredericksburg",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "fredericksburg-va-6",
      name: "University of Mary Washington",
      type: "Campus Resource",
      address: "1301 College Ave",
      city: "Fredericksburg",
      state: "VA",
      zip: "22401",
      phone: "(540) 654-1000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "College Heights neighborhood",
      website: "https://www.umw.edu",
      websiteLabel: "UMW Official Website",
      notes: "Not a passport acceptance facility but useful for UMW students and international programs. Check with student services.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "I-95 Drive to DC", agency: "Yes — 1+ hour each way in traffic", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Who Can Use It", agency: "Life-or-death emergencies only — proof required", fpc: "All travelers — urgent, expedited, or planned" },
    { feature: "Cost vs Resellers", agency: "Government fee only — no courier service", fpc: "30–100% less than FedEx, Staples, and other resellers" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Fredericksburg photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Rappahannock region acceptance facilities.",
    },
    {
      icon: "ri-route-line",
      title: "Underestimating I-95 Traffic",
      description: "Many Fredericksburg travelers plan to drive to the DC regional agency, not accounting for notorious I-95 delays that can make you miss your appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Fredericksburg families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Fredericksburg travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Fredericksburg or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fredericksburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Fredericksburg before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Fredericksburg for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround without the notorious I-95 drive to DC." },
    { q: "How fast can I renew my passport in Fredericksburg?", a: "Fast Passport Center offers fast passport renewal in Fredericksburg in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Fredericksburg?", a: "The nearest regional passport agency to Fredericksburg is the Washington Passport Agency, approximately 55 miles north in downtown Washington, DC — often 1.5-2 hours via I-95. For urgent processing without the drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Fredericksburg." },
    { q: "Do I need to drive to DC for an emergency passport in Fredericksburg?", a: "No. Fast Passport Center's registered courier service eliminates the need for Fredericksburg travelers to fight I-95 traffic to the Washington regional agency. We handle the entire process remotely — you ship your documents overnight and we deliver them to the State Department for you." },
    { q: "Can I expedite a child passport in Fredericksburg?", a: "Yes. Fast Passport Center expedites child passports in Fredericksburg for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Fredericksburg and Spotsylvania families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Fredericksburg with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Fredericksburg?", a: "With Fast Passport Center's emergency courier service, Fredericksburg travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Where are the closest passport acceptance facilities near Fredericksburg?", a: "Popular options include the Fredericksburg Main Post Office (22401), Spotsylvania Post Office (22551), Stafford Post Office (22554), and Culpeper Post Office (22701). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Spotsylvania or Stafford County?", a: "We serve the entire Rappahannock region including Spotsylvania County, Stafford County, King George County, Culpeper, Warrenton, and the I-95 corridor from Woodbridge to Richmond. Our overnight shipping labels work from any UPS location." },
    { q: "How much does expedited passport service cost in Fredericksburg?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Fredericksburg", address: "2201 Plank Rd, Fredericksburg, VA 22401", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Fredericksburg", address: "1001 Carl D. Silver Pkwy, Fredericksburg, VA 22401", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Fredericksburg", address: "3000 Plank Rd, Fredericksburg, VA 22401", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM", website: "https://www.fedex.com/" },
    { name: "CVS Pharmacy — Spotsylvania", address: "10900 Leavells Rd, Fredericksburg, VA 22407", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Stafford", address: "297 Garrisonville Rd, Stafford, VA 22554", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Culpeper", address: "316 James Madison Hwy, Culpeper, VA 22701", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Fredericksburg",
      address: "4049 Plank Rd, Fredericksburg, VA 22407",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Culpeper",
      address: "318 Garland Groh Blvd, Culpeper, VA 22701",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Stafford",
      address: "55 Pratt Dr, Stafford, VA 22556",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Stafford County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "Approximately 55 miles north of Fredericksburg",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "The closest major international airport to Fredericksburg. Flights to Europe, Asia, and worldwide destinations. Accessible via I-95 N and I-66.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 50 miles north of Fredericksburg",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Major domestic hub for flights across the U.S. Accessible via I-95 N.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Approximately 55 miles south of Fredericksburg",
      address: "1 Richard E. Byrd Terminal Dr, Henrico, VA 23250",
      note: "Regional hub serving Richmond and Central Virginia. Accessible via I-95 S.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "Approximately 85 miles north of Fredericksburg",
      address: "BWI Airport, Maryland 21240",
      note: "Major international hub serving the DC metro region. Accessible via I-95 N.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};